<h1 mat-dialog-title class="notification-title no-select">
	{{ 'mes.scanning-prefix.dialog.delete.header' | translate }}
</h1>
<div mat-dialog-content>
	<p>
		{{ 'mes.scanning-prefix.dialog.delete.content' | translate: { prefix: scanningPrefix.prefix } }}
	</p>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onDelete()" (window:keyup.enter)="onDelete()" [disabled]="loading">
		{{ 'mes.scanning-prefix.buttons.okbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" (click)="onCancel()" (window:keyup.escape)="onCancel()">
		{{ 'mes.scanning-prefix.buttons.cancelbtn' | translate }}
	</button>
</div>
